import React from "react";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormControl, MenuItem, Radio, Select } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { DateTimePicker } from "@mui/x-date-pickers";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Pause extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      vestigingen: [],
      selectedPauseTime: 60,
      menukaarten: [],
      pauseType: 0,
      openingOptions: [],
    };
  }

  componentDidMount() {
    this.loadNextStartDateTimes();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.salesAreaId !== this.props.salesAreaId) {
      this.loadNextStartDateTimes();
    }
  }

  loadNextStartDateTimes = () => {
    axios.post("core/vestigingen/nextStartDateTimes", { salesAreaId: this.props.salesAreaId }).then((response) => {
      if (response.data.data) {
        this.setState({ openingOptions: response.data.data });
      }
    });
  };

  handleType = (name) => (event) => {
    let val;
    if (name === "selectedPauseTime") {
      val = event;
    } else {
      if (typeof event.target.value === "string" && event.target.value.includes("|")) {
        val = event.target.value.split("|");
      } else {
        val = event.target.value;
      }
    }

    let newState = { ...this.state };
    newState[name] = val;
    this.setState(newState);
  };
  save = () => {
    let data = {
      product_ids: this.props.productIds,
      pause_duration: this.state.selectedPauseTime,
    };

    this.setState({ selectedPauseTime: "" });

    axios
      .post("core/producten/bulkPauseProduct", data)
      .then((response) => {
        this.setState({ saving: false });
        this.props.refreshTable();
        this.props.toggle();
      })
      .finally(() => {
        this.setState({ selectedPauseTime: 60 });
      });
  };

  render() {
    const { classes } = this.props;
    let pauseTimeOptions = [10, 30, 60, 120, 240, 480].map((prop) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={"PauseModalPauseTimeOption" + prop}
          value={prop}
        >
          {prop >= 60 ? prop / 60 : prop} <TranslationWrapper tKey={prop >= 60 ? "hour(s)" : "minutes"} />
        </MenuItem>
      );
    });

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        fullWidth
        keepMounted
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle
          className={classes.modalHeader}
          disableTypography
          id={"notice-modal-slide-title"}
          style={{ marginLeft: "42px" }}
        >
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Pause product"} tKey={"producten.modal.pause.titel"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem sm={12} xs={12}>
              <div style={{ display: "flex", justifyContent: "space-around", paddingBottom: "7px !important" }}>
                <div>
                  <Radio
                    checked={this.state.pauseType === 0}
                    color={"primary"}
                    onClick={() => {
                      this.setState({ pauseType: 0 });
                    }}
                    value={"0"}
                  />
                  <label>
                    <TranslationWrapper tDefault={"Quick"} tKey={"pause-products.quick"} />
                  </label>
                </div>
                {this.state.openingOptions.length > 0 ? (
                  <div>
                    <Radio
                      checked={this.state.pauseType === 1}
                      color={"primary"}
                      onClick={() => {
                        this.setState({ pauseType: 1 });
                      }}
                      value={"1"}
                    />
                    <label>
                      <TranslationWrapper tDefault={"Opening hours"} tKey={"pause-products.opening-hours"} />
                    </label>
                  </div>
                ) : null}

                <div>
                  <Radio
                    checked={this.state.pauseType === 2}
                    color={"primary"}
                    onClick={() => {
                      this.setState({ pauseType: 2 });
                    }}
                    value={"2"}
                  />
                  <label>
                    <TranslationWrapper tDefault={"Datetime"} tKey={"pause-products.datetime"} />
                  </label>
                </div>
              </div>
            </GridItem>

            <GridItem sm={12} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                {this.state.pauseType === 2 ? (
                  <DateTimePicker
                    closeOnSelect
                    label={"Pick a datetime"}
                    onChange={this.handleType("selectedPauseTime")}
                  />
                ) : null}

                {this.state.pauseType === 0 ? (
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    inputProps={{
                      name: "simpleSelect",
                      id: "simple-select",
                      style: { paddingTop: "32px" },
                    }}
                    onChange={this.handleType("selectedPauseTime")}
                    value={this.state.selectedPauseTime}
                  >
                    {pauseTimeOptions}

                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      key={"PauseModalPauseTimeOptionUntillTomorrow"}
                      value={"tomorrow"}
                    >
                      <TranslationWrapper
                        tDefault={"Until tomorrow"}
                        tKey={"product.form.pause.select.length.tomorrow"}
                      />
                    </MenuItem>
                  </Select>
                ) : null}

                {this.state.pauseType === 1 && this.state.openingOptions.length > 0 ? (
                  <Select onChange={this.handleType("selectedPauseTime")}>
                    {this.state.openingOptions.map((openingOption) => (
                      <MenuItem
                        key={JSON.stringify(openingOption)}
                        value={`${openingOption.dayNumber}|${openingOption.startTime}`}
                      >
                        <TranslationWrapper
                          tDefault={openingOption.dayName}
                          tKey={`pause_product.weekday.${openingOption.dayKey}`}
                        />{" "}
                        - {openingOption.startTime}
                      </MenuItem>
                    ))}
                  </Select>
                ) : null}
              </FormControl>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={<TranslationWrapper tDefault={"Pause"} tKey={"producten.modal.pause.button.save"} />}
            disabled={this.state.selectedPauseTime === ""}
            onClick={this.save}
            saving={this.state.saving}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(Pause, notificationsStyle);
